import { requestAPI } from './requestApi';

export const getEventsPreview = () => requestAPI('/events-preview');

export const getEvent = (eventId: string) => requestAPI(`/events/${encodeURI(eventId)}`);
